export { default } from './NotificationsCenter'
